module.exports = __webpack_public_path__ + "img/error-page-magnifier.c1d57b5.png";